<!-- <mat-toolbar>
    <span>Please Input your feedback</span>
    <span class="fill-remaining-space"></span>
    <button class="close" (click)='onClose()'>
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar> -->

<mat-toolbar class="toolbar-example">
    <span>Please Input your feedback</span>
    <span class="fill-remaining-space"></span>
    <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
</mat-toolbar>

<div mat-dialog-content>
    <form class="form-content-display" [formGroup]="textareaForm">
        <mat-form-field  class="feedback-field">
            <mat-label>Feedback</mat-label>
            <textarea formControlName="feedbackValue" matInput #feedbackValue></textarea>
        </mat-form-field>
    </form>
</div>
<!-- <div mat-dialog-actions>
    <button mat-button color="warn" type = "reset" (click) = "feedbackValue.value = ''">Clear</button>
    <button mat-button color="primary" [mat-dialog-close]="data" (click)='feedBackSubmit()'>Submit</button>
</div> -->

<div class="actions-example">
    <button mat-raised-button class="btn-cancel"  type = "reset" (click) = "feedbackValue.value = ''">Clear</button>
    <button mat-raised-button class="btn-color-example" style="margin-left: 10px;" [mat-dialog-close]="data" (click)='feedBackSubmit()'>Submit</button>
</div>